import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";


import CpntDragAndDropLists from "../../../components/CpntDragAndDropLists";
import { useBOSocieteUpdateActeursJuridiquesMutation, useFetchBOSocieteActeursJuridiquesQuery, useSearchBOSocieteActeurJuridiqueQuery } from "../../../redux/slice/api/BO/societeApi";
import { ISocieteUpdateActeursJuridiques } from "../../../models/interfaces/ISociete";
import { IKeyValueLibelle } from "../../../models/interfaces/IKeyValueLibelle";
import { IFilterActeursJuridiquesSearch, getDefaultFilterActeursJuridiques,filterToQuery, dtoToFilter } from "../../../models/interfaces/IFilterActeursJuridiquesSearch";

import { toast } from "react-toastify";
import CompteSocieteActeursJuridiquesFilter from "./CompteSocieteActeursJuridiquesFilter";
import { IActeurJuridique } from "../../../models/interfaces/IActeurJuridique";
import SpinnerEditeurPro from "../../FO/components/SpinnerEditeurPro";


interface IProps {
  IdSociete: number;
  refetch: boolean;
}


const BOCompteSocieteTabActeursJuridiques: React.FC<IProps> = ({ IdSociete,refetch }) => {

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
 

    const [listfilterActeursJuridiques, setListFilterActeursJuridiques] = useState<IFilterActeursJuridiquesSearch>(getDefaultFilterActeursJuridiques());
  const [searchParamsActeursJuridiques, setSearchParamsActeursJuridiques] = useState<IFilterActeursJuridiquesSearch>(getDefaultFilterActeursJuridiques());
  const applyFilterActeursJuridiques = (data: IFilterActeursJuridiquesSearch) => {
    setListFilterActeursJuridiques(data);
  }


  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterActeursJuridiquesSearch");
    if (storedFilter !== null && storedFilter !== undefined) {
      setListFilterActeursJuridiques(JSON.parse(storedFilter));
    }
  }, []);

  useEffect(() => {
    if (IdSociete && listfilterActeursJuridiques) {
      const _filter: IFilterActeursJuridiquesSearch = filterToQuery({
        ...listfilterActeursJuridiques,
        IdSociete: IdSociete,
      });
      setSearchParamsActeursJuridiques(_filter);
    }
  }, [IdSociete, listfilterActeursJuridiques]);


  /*ActeursJuridiques */
  const [sourceActeursJuridiques, setSourceActeursJuridiques] = useState<IKeyValueLibelle[]|undefined>([]);
  const [destinationActeursJuridiques, setDestinationActeursJuridiques] = useState<IKeyValueLibelle[]|undefined>([]);
  const [destinationActeursJuridiquesResult, setDestinationActeursJuridiquesResult] = useState<IKeyValueLibelle[]|null>(null);

  //const [fetchSearchActeursJuridiques, setFetchSearchActeursJuridiques] = useState(refetch);
  const [fetchSocieteActeursJuridiques, setFetchSocieteActeursJuridiques] = useState(refetch);

  //Recherche ActeursJuridiques
  const { data: SearchActeursJuridiquesResult, isFetching: SearchActeursJuridiquesisFetching, error: SearchActeursJuridiqueserror} = useSearchBOSocieteActeurJuridiqueQuery(searchParamsActeursJuridiques, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParamsActeursJuridiques === null || searchParamsActeursJuridiques === undefined || searchParamsActeursJuridiques?.SearchLibelle === undefined || searchParamsActeursJuridiques?.SearchLibelle === "" , //|| fetchSearchActeursJuridiques ===false
  });

  //ActeursJuridiques affectés a la societe
  const { data: SocieteActeursJuridiquesResult, isFetching: SocieteActeursJuridiquesisFetching, error: SocieteActeursJuridiqueserror,refetch:refetchBOSocieteActeursJuridiques} = useFetchBOSocieteActeursJuridiquesQuery(IdSociete, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || IdSociete === 0 || fetchSocieteActeursJuridiques === false,
  });

  useEffect(() => {
    //setFetchSearchActeursJuridiques(refetch);
    setFetchSocieteActeursJuridiques(refetch);
  }, [refetch])


  const [
    BOSocieteUpdateActeursJuridiques,
    {
    isSuccess: isSuccessUpdateActeursJuridiques,
    error: errorBOSocieteUpdateActeursJuridiques,
    isLoading: isLoadingUpdateActeursJuridiques
  }] = useBOSocieteUpdateActeursJuridiquesMutation();


  const PaintSourceActeursJuridiques = () => {
    setSourceActeursJuridiques([]);

    const Tasks: React.SetStateAction<IKeyValueLibelle[] | undefined> = [];

    SearchActeursJuridiquesResult?.ActeursJuridiques?.forEach((elem: IActeurJuridique) => {
      Tasks.push({
        value: elem.IdExterne?.toString(), //IdCalipse
        key: elem.IdExterne?.toString(), //IdCalipse
        Libelle: elem.Libelle 
      });
    });
    
    setSourceActeursJuridiques(Tasks);

  }

  const PaintDestinationActeursJuridiques = () => {
    setDestinationActeursJuridiques([]);

    const Tasks: React.SetStateAction<IKeyValueLibelle[] | undefined> = [];

    SocieteActeursJuridiquesResult?.ActeursJuridiques?.map((elem:IActeurJuridique) => {
      Tasks.push({
        value: elem.IdExterne?.toString(), //IdCalipse
        key: elem.IdExterne?.toString(), //IdCalipse
        Libelle: elem.Libelle 
      });
    });
    
    setDestinationActeursJuridiques(Tasks);
  }

  const AnnulerActeursJuridiquesCommand = () => {
    PaintDestinationActeursJuridiques();
    PaintSourceActeursJuridiques();
  }
 

  useEffect(() => {
    if (!SearchActeursJuridiquesisFetching && !isLoadingUpdateActeursJuridiques && SearchActeursJuridiqueserror === undefined) {
      PaintSourceActeursJuridiques();
    } else {
      setSourceActeursJuridiques(undefined);
    }
  }, [SearchActeursJuridiquesisFetching,SearchActeursJuridiquesResult,isSuccessUpdateActeursJuridiques])


  useEffect(() => {
    if (!SocieteActeursJuridiquesisFetching && !isLoadingUpdateActeursJuridiques && SocieteActeursJuridiqueserror === undefined) {
      PaintDestinationActeursJuridiques();
    } else {
      setDestinationActeursJuridiques(undefined);
    }
  }, [SocieteActeursJuridiquesisFetching,SocieteActeursJuridiquesResult,isSuccessUpdateActeursJuridiques])


  useEffect(() => {
    if (errorBOSocieteUpdateActeursJuridiques !== undefined) {
      toast.warn("Les modifications n'ont pas été prises en compte");
      refetchBOSocieteActeursJuridiques();
    }
}, [errorBOSocieteUpdateActeursJuridiques])

useEffect(() => {
  if (isSuccessUpdateActeursJuridiques) {
    toast.success("Les modifications ont bien été prises en compte.");
    refetchBOSocieteActeursJuridiques();
  }
}, [isSuccessUpdateActeursJuridiques])

  useEffect(() => {

    if (destinationActeursJuridiquesResult) {
      const result: ISocieteUpdateActeursJuridiques = {
        IdSociete:  IdSociete,
        ActeursJuridiques: destinationActeursJuridiquesResult?.map(m => ({
            IdExterne: parseInt(m.value),
            Libelle: m.Libelle
        }))
    };
    BOSocieteUpdateActeursJuridiques(result);
    }
  }, [destinationActeursJuridiquesResult])

 
  return (
    <>
          <CompteSocieteActeursJuridiquesFilter 
            filter={dtoToFilter(searchParamsActeursJuridiques)}
            changeFilter={applyFilterActeursJuridiques}
              />
        {isLoadingUpdateActeursJuridiques 
        ?
        <SpinnerEditeurPro text="Mise à jour en cours..." />
        : 
          <CpntDragAndDropLists 
          titresource="Votre recherche" 
          source={sourceActeursJuridiques} 
          sourceIsFetching={SearchActeursJuridiquesisFetching}
          titredestination="Fonds attribué" 
          destination={destinationActeursJuridiques} 
          destinationIsFetching={SocieteActeursJuridiquesisFetching}
          cmdValider={setDestinationActeursJuridiquesResult} 
          cmdAnnuler={AnnulerActeursJuridiquesCommand} />
        }
        
    </>
  )
    
}; 

export default BOCompteSocieteTabActeursJuridiques;

